import { CustomFilterSearch, NestedSelectableOptions, SelectableOptions } from './searchable-dropdown.type';

export const getFilteredNestedOptionsWithStructure = (
    options: NestedSelectableOptions[],
    filter: string
): NestedSelectableOptions[] => {
    if (!filter) {
        return options;
    }

    const query = filter.toLowerCase();

    return options
        .map((option) => {
            const parentMatches =
                option.name.toLowerCase().includes(query) || option?.secondaryText?.toLowerCase().includes(query);

            const filteredChildren = option.children?.filter((child) => child.name.toLowerCase().includes(query)) || [];
            const allChildren = option.children || [];

            if (parentMatches || filteredChildren.length > 0) {
                return {
                    ...option,
                    children: allChildren,
                };
            }

            return null;
        })
        .filter((option): option is NestedSelectableOptions => option !== null);
};

export const getFilteredNestedOptions = (options: NestedSelectableOptions[], filter: string) => {
    const filteredWithStructure = getFilteredNestedOptionsWithStructure(options, filter);

    return filteredWithStructure.flatMap((option) => (option.children?.length ? option.children : [option]));
};

export const getFilteredNestedChildren = (options: NestedSelectableOptions[], filter: string) =>
    getFilteredNestedOptionsWithStructure(options, filter).flatMap((option) => option.children ?? []);

export const getSelectAllCandidates = (options: SelectableOptions[]) =>
    options.filter((option) => !option.excludedFromSelectAll);

export const getFilteredFlatOptions = (options: SelectableOptions[], filter: string) => {
    if (!filter) {
        return options;
    }

    return options.filter(
        (option) =>
            option.name.toLowerCase().includes(filter.toLowerCase()) ||
            option?.secondaryText?.toLowerCase().includes(filter.toLowerCase())
    );
};

export const getSelectedhiddenOptions = (
    options: SelectableOptions[],
    visibleOptions?: (SelectableOptions | NestedSelectableOptions)[],
    selectedIds?: string[],
    customFilter?: CustomFilterSearch
) => {
    const visibleIds = new Set<string>(
        visibleOptions?.flatMap((option) =>
            'children' in option && option.children
                ? [option.id, ...option.children.map((child) => child.id)]
                : [option.id]
        ) ?? []
    );

    if (customFilter) {
        const customFilterSelectedOptions = customFilter.selectedOptions || [];
        return customFilterSelectedOptions.filter((option) => !visibleIds.has(option.id));
    }

    if (selectedIds) {
        return options.filter((option) => selectedIds.includes(option.id) && !visibleIds.has(option.id));
    }

    return [];
};
